import { publicApiFetch } from '~/utils/apiFetch'
import type {
  ForgotPasswordVerifyRequestDto,
  LoginRequestDto,
  LoginResultDto,
  OAuthConfigDto,
  OAuthLoginRequestDto,
  OAuthLoginResultDto,
  OAuthProvider,
  ResetPasswordRequestDto,
  SendCodeRequestDto,
  WalletLoginRequestDto,
  WalletNonceRequestDto,
  WalletNonceResultDto,
} from '~/types/api/login'

/** POST /api/v1/account/login — 登录 / 注册（新用户自动创建账号） */
export function login(payload: LoginRequestDto) {
  return publicApiFetch<LoginResultDto>('/account/login', {
    method: 'POST',
    body: payload,
  })
}

/** GET /api/v1/account/oauth/config — 第三方登录公开配置（渠道开关 + SDK 公开标识） */
export function fetchOAuthConfig() {
  return publicApiFetch<OAuthConfigDto>('/account/oauth/config', {
    skipErrorToast: true,
  })
}

/** POST /api/v1/account/oauth/{provider} — 第三方快捷登录 / 注册 */
export function oauthLogin(provider: OAuthProvider, payload: OAuthLoginRequestDto) {
  return publicApiFetch<OAuthLoginResultDto>(`/account/oauth/${provider}`, {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/wallet/nonce — 钱包登录申请挑战文本（SIWE，绑定 Origin，5 分钟一次性） */
export function fetchWalletNonce(payload: WalletNonceRequestDto) {
  return publicApiFetch<WalletNonceResultDto>('/account/wallet/nonce', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/wallet/login — 钱包签名登录 / 注册 */
export function walletLogin(payload: WalletLoginRequestDto) {
  return publicApiFetch<LoginResultDto>('/account/wallet/login', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/verification-code — 发送邮箱 / 短信验证码 */
export function sendVerificationCode(payload: SendCodeRequestDto) {
  return publicApiFetch<unknown>('/account/verification-code', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/password/forgot/verify — 找回密码-校验身份（不消费验证码） */
export function verifyForgotPassword(payload: ForgotPasswordVerifyRequestDto) {
  return publicApiFetch<unknown>('/account/password/forgot/verify', {
    method: 'POST',
    body: payload,
  })
}

/** POST /api/v1/account/password/forgot/reset — 找回密码-重置密码（消费验证码） */
export function resetForgotPassword(payload: ResetPasswordRequestDto) {
  return publicApiFetch<unknown>('/account/password/forgot/reset', {
    method: 'POST',
    body: payload,
  })
}
